import React, { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import WorkspacePage from "../../../components/WorkspacePage";
import EmailMessagesTab from "./EmailMessagesTab";
import EmailTemplatesTab from "./EmailTemplatesTab";

const EmailCenter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(searchParams.get("tab") || "messages");

  const handleTabChange = (event, value) => {
    setCurrentTab(value);
    const nextParams = new URLSearchParams(searchParams);
    if (value === "templates") {
      nextParams.set("tab", value);
    } else {
      nextParams.delete("tab");
    }
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <WorkspacePage>
      <PageHeader
        title="Email Center"
        tabs={
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab value="messages" label="Messages" data-tour-id="tour-email-tab-messages" />
            <Tab value="templates" label="Templates" data-tour-id="tour-email-tab-templates" />
          </Tabs>
        }
      />

      {currentTab === "messages" && <EmailMessagesTab />}
      {currentTab === "templates" && <EmailTemplatesTab />}
    </WorkspacePage>
  );
};

export default EmailCenter;
